import { UserprofileEdit } from "components/jobseeker/userprofileEdit/Userprofile";
import { CompanyProfileEdit } from "components/recruiter/recruiterEditable/CompanyProfileEdit";
import storage from "utils/storage";

export const Profile = () => {
  if (storage.get("humlog_user_role") === 0) {
    return <UserprofileEdit />;
  } else return <CompanyProfileEdit />;
};
